export default "__VITE_ASSET__DFY4dPzM__"